import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Templates } from 'generated/graphql';

export type TModalView = 'planificacion' | 'bloques' | 'rubrica' | 'sesion' | 'guia' | 'instrumento' | 'ruta';
export type TTipoActividad = 'individual' | 'grupal' | undefined;
export type TPreview =
	| 'planificacion'
	| 'sesion'
	| 'guiaGrupal'
	| 'guiaIndividual'
	| 'rubricaIndividual'
	| 'rubricaGrupal'
	| '';
export type TTablePlantilla = 'sesion' | 'guia' | 'instrumento' | 'ruta' | undefined;

interface IInitialState {
	plantillaKey: string;
	displayTable: boolean;
	tablePlantilla: TTablePlantilla;
	preview: TPreview;
	modalView: TModalView;
	tipoActividad: TTipoActividad;
	elementoKey: string;
	listadoGuiasKeys?: {
		guiaIndividual: string;
		guiaGrupal: string;
	};
	listadoRubricasKeys?: {
		rubricaIndividual: string[];
		rubricaGrupal: string[];
		// rubricaIndividual: Actividades_Rubrica[];
		// rubricaGrupal: Actividades_Rubrica[];
	};
	isPreview: boolean;
	tipoView: 'view' | 'edit' | undefined;
	subElementKey?: string;
	pickedPlantilla?: {
		key: string;
		template_name: string;
		template_desc: string;
	};
	dataAsignPlantilla?: Templates | undefined;
	keyOrigenAsignar?: string;
	isSesionInstrumentos?: boolean;
}

const initialState: IInitialState = {
	plantillaKey: '',
	displayTable: false,
	tablePlantilla: undefined,
	preview: '',
	modalView: 'sesion',
	tipoActividad: undefined,
	elementoKey: '',
	isPreview: false,
	tipoView: undefined,
	isSesionInstrumentos: false
};

/*
plantillaKey: es la llave que representa la raiz de la plantilla, de ahi hacia abajo esta asociado todo lo que este para esa plantilla
display: es para mosttrar
displayTable: es para mostrar la tabla de plantillas en la vista de plan y otras,
tablePlantilla: es para saber que tabla de plantillas se esta mostrando, si sesion, guia o instrumento o todas,
status: Esta seria edit / view  para definir si la plantilla se esta editando o viendo
isASign: esto seria un booleano para definir si se esta asignando la plantilla o no
tipoActividadAsign: Es para definir el tipo de la actividad que se intenta asignar
listadoGuiasKeys y listadoRubricasKeys: son para guardar las llaves de las guias y rubricas que se estan usando en la plantilla, esto es para la vista de preview
*/
const plantilasModalSlice = createSlice({
	name: 'plantilasModal',
	initialState,
	reducers: {
		displayPlantillaTable: (state) => {
			return { ...state, displayTable: true };
		},
		closePlantillaTable: (state) => {
			return { ...state, displayTable: false };
		},
		setTipoTablaPlantilla: (state, action) => {
			return {
				...state,
				displayTable: true,
				tablePlantilla: action.payload.tablePlantilla,
				tipoActividad: action.payload.tipoActividad,
				keyOrigenAsignar: action.payload.keyOrigenAsignar
			};
		},
		setPickedPlantilla: (state, action) => {
			return {
				...state,
				dataAsignPlantilla: action.payload
			};
		},
		setTipoActividadPlantilla: (state, action: PayloadAction<TTipoActividad>) => {
			return { ...state, tipoActividad: action.payload };
		},
		setModalViewPlantilla: (state, action: PayloadAction<TModalView>) => {
			return { ...state, modalView: action.payload };
		},
		setPlantillaModalEdit: (state, action) => {
			return {
				...state,
				preview: '',
				plantillaKey: action.payload.plantillaKey,
				modalView: action.payload.modalView,
				elementoKey: action.payload.elementoKey,
				tipoView: 'edit',
				isSesionInstrumentos: action.payload.isSesionInstrumentos
			};
		},
		setPlantillaModalEditInsideSesion: (state, action) => {
			return {
				...state,
				subElementKey: action.payload.subElementKey,
				modalView: action.payload.modalView
			};
		},
		goBackPlantillaModalEdit: (state) => {
			return {
				...state,
				subElementKey: undefined,
				modalView: 'sesion'
			};
		},
		setPlantillaModalPreview: (state, action) => {
			return {
				...state,
				tipoView: 'view',
				plantillaKey: action.payload.plantillaKey,
				preview: action.payload.preview,
				modalView: action.payload.modalView,
				isPreview: action.payload.isPreview,
				elementoKey: action.payload.elementoKey,
				listadoGuiasKeys: action.payload.listadoGuiasKeys,
				listadoRubricasKeys: action.payload.listadoRubricasKeys
			};
		},
		closePlantillaModalDetail: (state) => {
			// {"plantillaKey":"","displayTable":true,"tablePlantilla":"guia","preview":"","modalView":"sesion","tipoActividad":"individual","elementoKey":"","isPreview":false}
			return {
				...state,
				plantillaKey: ''
			};
		},
		resetPlantillaModal: (state) => {
			return initialState;
		}
	}
});

export const {
	displayPlantillaTable,
	setTipoTablaPlantilla,
	closePlantillaTable,
	setPickedPlantilla,
	setPlantillaModalPreview,
	setPlantillaModalEdit,
	resetPlantillaModal,
	setTipoActividadPlantilla,
	setModalViewPlantilla,
	setPlantillaModalEditInsideSesion,
	goBackPlantillaModalEdit,
	closePlantillaModalDetail
} = plantilasModalSlice.actions;

export default plantilasModalSlice.reducer;
